import { $api } from './interceptor';
import {
  IAdminPermissions,
  IRole,
  IUpdateRolePermissions,
  IPermissionCheck,
  IAccessibleResources,
} from 'views/types/permissions';

const permissionsApi = () => {
  const getMyPermissions = async (): Promise<IAdminPermissions> => {
    const { data } = await $api.get<IAdminPermissions>(
      '/api/admin/permissions/me'
    );
    return data;
  };

  const getAllRoles = async (): Promise<IRole[]> => {
    const { data } = await $api.get<IRole[]>('/api/admin/permissions/roles');
    return data;
  };

  const updateRolePermissions = async (
    roleId: string,
    permissions: IUpdateRolePermissions
  ): Promise<{ message: string }> => {
    const { data } = await $api.patch<{ message: string }>(
      `/api/admin/permissions/roles/${roleId}`,
      permissions
    );

    return data;
  };

  const checkPermission = async (
    resource: string,
    action: string
  ): Promise<IPermissionCheck> => {
    const { data } = await $api.get<IPermissionCheck>(
      `/api/admin/permissions/check/${resource}/${action}`
    );
    return data;
  };

  const getAccessibleResources = async (): Promise<IAccessibleResources> => {
    const { data } = await $api.get<IAccessibleResources>(
      '/api/admin/permissions/accessible-resources'
    );
    return data;
  };

  const createRole = async (roleData: {
    name: string;
    description: string;
    permissions: Record<
      string,
      { read: boolean; create: boolean; update: boolean; delete: boolean }
    >;
  }): Promise<IRole> => {
    const { data } = await $api.post<IRole>(
      '/api/admin/permissions/roles',
      roleData
    );
    return data;
  };

  const deleteRole = async (roleId: string): Promise<{ message: string }> => {
    const { data } = await $api.delete<{ message: string }>(
      `/api/admin/permissions/roles/${roleId}`
    );
    return data;
  };

  return {
    getMyPermissions,
    getAllRoles,
    updateRolePermissions,
    checkPermission,
    getAccessibleResources,
    createRole,
    deleteRole,
  };
};

export const permissionsService = permissionsApi();
